export default __webpack_public_path__ + "static/level_game-c612edc72c8ecc0fc8d42317f84081ee.webp";